<template>
  <article class="category">
    <section class="section">
      <div class="container">
        <h1
          v-show="tagTitle"
          class="mb-[24px] font-roboto text-[32px] font-medium leading-[36px]"
        >
          Материалы по тегу &laquo;{{ tagTitle }}&raquo;
        </h1>
        <!-- <div
          v-show="articles?.length"
          class="my-14 flex flex-col justify-between lg:flex-row"
        >
          <CommonTabs
            class="w-fit"
            :list="sortOptions"
            :initial-tab-index="currentTabIndex"
            @on-change="handleSortValue"
          />
        </div> -->
        <div v-if="articles" class="grid-layout gap-8">
          <MainPageCardsReworkedBaseCard
            v-for="article in articles"
            :key="`article-${article.id}`"
            class="col-span-full md:col-span-6 lg:col-span-4 xl:col-span-3"
            :data="article"
            disable-announce
          />
        </div>
        <div class="mt-[64px] flex justify-center">
          <BaseTheButtonNew
            v-if="articlesByTag.hasNextPage.value"
            text="Показать еще"
            @click="articlesByTag.fetchNextPage()"
          />
        </div>
      </div>
    </section>
    <CommonBlocksPageFooterBlocks />
  </article>
</template>

<script setup>
const route = useRoute();
const slug = route?.params?.slug;

const selectedSortValue = ref('');
// const sortOptions = [ // SUPPORT-1166
//   { id: 0, name: 'Свежие', model: '', icon: 'timer' },
//   { id: 1, name: 'Популярные', model: 'views', icon: 'eye' },
// ];

const filters = computed(() => {
  return {
    sort_by: selectedSortValue.value,
  };
});

const { articlesByTag, resetPage } = useArticlesByTag({ slug, filters });
const articles = computed(() => articlesByTag?.data?.value);
watch(filters, (_, prevValue) => resetPage(prevValue));

const tagTitle = computed(() => {
  const foundTag = articles.value?.[0].tags.find(tag => tag.slug === slug);
  return foundTag?.title || articles.value?.[0]?.title;
});
// const handleSortValue = (e) => (selectedSortValue.value = e);
// const currentTabIndex = computed(
//   () => sortOptions.find((item) => item.model === selectedSortValue.value)?.id,
// );

useHead(
  computed(() => ({
    title: `${
      tagTitle.value ? `${tagTitle.value} |` : ''
    } Федеральный портал Истории России`,
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: `Материалы по тегу «${tagTitle.value}». Федеральный портал Истории России.`,
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: `${tagTitle.value}`,
      },
    ],
  })),
);
</script>

<style lang="scss"></style>
